import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { Dispatch, memo, SetStateAction } from "react";

const InstallmentNonActiveModal = ({
  open,
  setOpen
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => (
  <Modal
    animate="normal"
    dialogClassName="lg:max-w-[439px]"
    mobileHeight="auto"
    onClose={() => setOpen(false)}
    open={open}
  >
    <div>
      <div className="m-0 flex items-center justify-between pb-4">
        <div className="flex cursor-pointer items-center gap-4 text-lg font-medium text-opacity-[87%]">
          وضعیت پرداخت قسطی{" "}
        </div>
        <MaterialIcon
          className="cursor-pointer text-2xl opacity-60"
          name="close"
          onClick={() => setOpen(false)}
          variant="outlined"
        />
      </div>
      <div className="text-body-2 text-on-surface-high-emphasis">
        <div className="mb-4">
          امکان پرداخت اقساطی با اسنپ‌پی به دلیل{" "}
          <span className="text-body-1 font-bold">عدم ثبت‌نام</span> یا{" "}
          <span className="text-body-1 font-bold">بدهی قبلی</span> برای این
          شماره موبایل
          <span className="text-body-1 font-bold"> فعال نیست</span>. لطفاً حساب
          خود در اسنپ‌پی را بررسی و در صورت نیاز ثبت‌نام کنید.
        </div>
        <div>
          پس از رفع مشکل، از حساب اسنپ‌تریپ{" "}
          <span className="text-body-1 font-bold">خارج</span> شده و دوباره{" "}
          <span className="text-body-1 font-bold">وارد</span> شوید تا پرداخت
          اقساطی فعال شود.{" "}
        </div>
      </div>
      <div className="flex justify-end pt-4">
        <Button
          color="secondary"
          onClick={() => setOpen(false)}
          variant="contained"
        >
          متوجه شدم
        </Button>
      </div>
    </div>
  </Modal>
);

export default memo(InstallmentNonActiveModal);
